import { render, staticRenderFns } from "./PadoPlayerComponent.vue?vue&type=template&id=7fa4ffe2&scoped=true"
import script from "./PadoPlayerComponent.vue?vue&type=script&lang=ts"
export * from "./PadoPlayerComponent.vue?vue&type=script&lang=ts"
import style0 from "./PadoPlayerComponent.vue?vue&type=style&index=0&id=7fa4ffe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa4ffe2",
  null
  
)

export default component.exports